import React, { useEffect, useState } from "react"
import { Card, Col, Container, Row } from "react-bootstrap"
import { GetCollection } from "../../../firebase/firebase"


export const MissionProfileList = () => {

    const [people, setPeople] = useState([])
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        if (loading) {
            GetCollection('users', true, 'role', 'admin').then((data) => {
                setPeople(data.docs.map(doc => doc.data()))
            })

        }
    }, [])

    return (
        <>
            <Container fluid>
                <Row className='d-flex justify-content-center align-items-center'>
                    <Col md={6}>
                        <MissionStatement />
                    </Col>
                </Row>
                <Row>
                    {people && people.map((person, i) => {
                        return (
                            <MissionProfile person={person} key={i} />
                        )
                    })}
                </Row>
            </Container>
        </>
    )
}
const MissionStatement = () => {
    return (
        <>
            <Row className='d-flex justify-content-center align-items-center'>
                <Col className='d-flex justify-content-center align-items-center'>
                    <h4>Mission Statement</h4>
                </Col>
            </Row>
            <Row className='d-flex justify-content-center align-items-center'>
                <Col className='d-flex justify-content-center align-items-center'>
                    <p>Hello everyone!!! We created this as a consolidated resource for patients and healthcare workers to get more information on diet and lifestyle strategies. Losing weight is hard and often overwhelming. We hope that by providing recipes, videos, and operating an interactive forum this site will be inclusive to all types of learners. Please let us know if there is anything not included that you would want to know more about by leaving us a comment in the forum! Thanks for checking out our page.</p>
                </Col>
            </Row>
        </>
    )
}

const MissionProfile = (props) => {
    const person = props.person


    return (
        <>

            <Col sm={6} md={4} lg={3} className='p-4'>
                <Card className='h-100 w-75'>
                    <Card.Img variant="top" src={person.image} />
                    <Card.Body>
                        <Card.Title>
                            {person.firstName} {person.lastName}
                        </Card.Title>

                        <Card.Text>
                            {person.description}
                        </Card.Text>

                    </Card.Body>
                </Card>
            </Col>

        </>
    )
}